import { db } from '../services/db'
/* import type { MinimindDB } from '@@/types/database' */

const TABLES = ['notes', 'entries', 'tasks', 'lists', 'labels', 'contexts']
const RETENTION_DAYS = 7

export async function purgeAllObsoleteItems() {
  /*   const now = Date.now() */
  const cutoff = new Date(Date.now() - RETENTION_DAYS * 24 * 60 * 60 * 1000)

  const promises = TABLES.map(async (table) => {
    await (db as any)[table].where('deletedAt').below(cutoff).delete()
  })

  await Promise.all(promises)
}
